import { ConversationStatus } from '@ekhodealer/ekho-common';

import type { TagProps } from '@ekhodealer/ekho-common/rev';

interface ConversationStatusConfig {
	/** Human-readable label for the status */
	label: string;
	/** Tag accent color for visual distinction */
	accent: TagProps['accent'];
}

export const CONVERSATION_STATUS_CONFIG: Record<
	(typeof ConversationStatus)[keyof typeof ConversationStatus],
	ConversationStatusConfig
> = {
	active: { label: 'Active', accent: 3 },
	processing: { label: 'Processing', accent: 1 },
	escalated: { label: 'Escalated', accent: 5 },
	completed: { label: 'Completed', accent: 'neutral' },
	failed: { label: 'Failed', accent: 4 },
	[ConversationStatus.OptedOut]: { label: 'Opted Out', accent: 'neutral' },
	[ConversationStatus.TimedOut]: { label: 'Timed Out', accent: 'neutral' },
	idle: { label: 'Idle', accent: 'neutral' },
};
